import { useContext, useEffect } from 'react';
import OLVectorLayer from 'ol/layer/Vector';
import { Vector } from 'ol/source';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import PropTypes from 'prop-types';
import GeoMapContext from '../../lib/geo-map/GeoMapContext';
import { useAppSelector } from '../../../app/store';
import reducerPath from '../../../app/reducerPath';
import {
  vectorStyleCurrentPoint,
  vectorStyleRoutePoint,
  vectorStyleRoutePointNumberInsideMarker,
  vectorStyleRoutePointOnlyTextMarker,
} from './constants';
import { customVehicleStyle } from './utils';
// eslint-disable-next-line
import { useGetVehicleModelIconQuery } from '../../../entities/vehicles/vehicle/redux/vehicle.api';

// Создает и отображает маркер ТС на карте
function MarkerVectorLayer(props) {
  const token = window.localStorage.getItem('token') || window.sessionStorage.getItem('token');

  const {
    zIndex,
    coordinates,
    text,
    point,
    numerary,
    tooltipText,
    numeraryInAnotherLayout,
    title,
    isCurrentPoint,
    icoColor,
    vehicleCustomIcon,
    vehicleModelId,
    vehicleIconColor,
    opacity,
  } = props;

  // текущая карта
  const { map } = useContext(GeoMapContext);
  const isFollowMode = useAppSelector((state) => state[`${reducerPath.followMode}/counter`]).isActive;
  const zoomController = useAppSelector((state) => state[`${reducerPath.zoomController}/counter`]).zoom;

  const { data: vehicleIconBase64 } = useGetVehicleModelIconQuery({
    vehicleCustomIcon,
    vehicleModelId,
    token,
  });

  // Создание и отображение маршрута
  useEffect(() => {
    const needWaitForServerIcon = vehicleModelId !== 0 && !vehicleIconBase64;
    if (needWaitForServerIcon || !map) return undefined;

    // source для слоя по умолчанию, если координаты не переданы
    let source = new Vector({
      projection: map.getView().projection,
    });

    // если переданы координаты
    if (coordinates?.length) {
      // Маркер ТС
      const markerFeature = new Feature({
        geometry: new Point(coordinates),
        tooltipText,
      });
      source = new VectorSource({
        features: [markerFeature],
      });
    }

    let newVectorLayer;
    let newVectorLayer2;

    if (numeraryInAnotherLayout && point) {
      // создание векторного слоя
      newVectorLayer = new OLVectorLayer({
        source,
        style: () => {
          const style = vectorStyleRoutePointOnlyTextMarker;
          style.getText().setText(title);
          return style;
        },
      });
      map.addLayer(newVectorLayer);
      newVectorLayer.setZIndex(zIndex);

      newVectorLayer2 = new OLVectorLayer({
        source,
        style: () => {
          const style = vectorStyleRoutePointNumberInsideMarker;
          style.getText().setText(text);
          return style;
        },
      });
      map.addLayer(newVectorLayer2);
      newVectorLayer2.setZIndex(zIndex + 1);
    } else {
      // создание векторного слоя
      newVectorLayer = new OLVectorLayer({
        source,
        style: () => {
          const style = point
            ? numerary
              ? vectorStyleRoutePointNumberInsideMarker
              : vectorStyleRoutePoint
            : isCurrentPoint
              ? vectorStyleCurrentPoint
              : customVehicleStyle(vehicleIconBase64, text, opacity, icoColor, vehicleIconColor);

          style?.getText().setText(text);

          return style;
        },
      });
      map.addLayer(newVectorLayer);
      newVectorLayer.setZIndex(zIndex);
    }

    return () => {
      if (map) {
        map.removeLayer(newVectorLayer);
        map.removeLayer(newVectorLayer2);
      }
    };
  }, [map, coordinates, zIndex, text, point, isFollowMode, zoomController, isCurrentPoint, vehicleIconBase64]);

  return null;
}

MarkerVectorLayer.propTypes = {
  zIndex: PropTypes.number,
  coordinates: PropTypes.arrayOf(PropTypes.number),
  text: PropTypes.string,
  point: PropTypes.bool,
  numerary: PropTypes.bool,
  tooltipText: PropTypes.string,
  numeraryInAnotherLayout: PropTypes.bool,
  title: PropTypes.string,
  isCurrentPoint: PropTypes.bool,
  icoColor: PropTypes.oneOf('red', 'green', 'yellow'),
  vehicleCustomIcon: PropTypes.string,
  vehicleModelId: PropTypes.number,
  vehicleIconColor: PropTypes.string,
  opacity: PropTypes.number,
};

MarkerVectorLayer.defaultProps = {
  zIndex: 4,
  coordinates: [],
  text: '',
  point: false,
  numerary: null,
  tooltipText: '',
  numeraryInAnotherLayout: false,
  title: null,
  isCurrentPoint: false,
  icoColor: undefined,
  vehicleCustomIcon: null,
  vehicleModelId: 0,
  vehicleIconColor: '',
  opacity: 1,
};

export default MarkerVectorLayer;
